import React from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { IconButton as MuiIconButton, styled, Tooltip } from "@mui/material";

const StyledIconButton = styled(MuiIconButton)(({ theme }) => ({
  borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
  borderTop: "1px solid rgba(255, 255, 255, 0.12)",
  height: 16,
  minHeight: 16,
  padding: 0,

  "&.active": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  "&:not(.active)": {
    backgroundColor: "inherit",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

interface ToggleOptionButtonProps {
  onClick: (e: React.MouseEvent) => void;
  active?: boolean;
  title?: string;
}

const ToggleOptionButton: React.FC<ToggleOptionButtonProps> = ({ onClick, active = false, title = "Configure options" }) => {
  return (
    <Tooltip title={title}>
      <StyledIconButton size="small" onClick={onClick} className={active ? "active" : undefined}>
        <KeyboardArrowDown sx={{ fontSize: 14 }} />
      </StyledIconButton>
    </Tooltip>
  );
};

export default ToggleOptionButton;
